import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "@store/thunks/studentLogin";

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(logoutUser());
    navigate("/");
  };

  // Map URL paths to error details
  const errorConfig = {
    "/unauthorized": {
      title: "Session Expired",
      message: "Please login again to continue.",
    },
    "/forbidden": {
      title: "Forbidden",
      message: "Access to this resource is denied.",
    },
    "/not-found": {
      title: "Page Not Found",
      message: "The page you are looking for does not exist.",
    },
    "/server-error": {
      title: "Server Error",
      message: "Something went wrong on our end. Please try again later.",
    },
  };

  const { title, message } = errorConfig[location.pathname] || {
    title: "Error",
    message: "An unexpected error occurred.",
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-8">
      <div className="bg-white shadow-lg rounded-2xl p-8 text-center w-full max-w-md border border-gray-200">
        {/* SVG Icon */}
        <svg
          className="w-20 h-20 mx-auto mb-4 text-red-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>

        {/* Title */}
        <h1 className="text-3xl font-semibold text-gray-800 mb-4 font-['Semantic/Strong']">
          {title}
        </h1>

        {/* Message */}
        <p className="text-gray-600 text-lg mb-6">{message}</p>

        {/* Error Reason if passed via state */}
        {location.state?.message && (
          <div className="mb-6 p-4 rounded-lg bg-red-100 text-red-700 font-['Semantic/Strong'] text-sm">
            <span className="font-medium">Reason:</span>{" "}
            {location.state.message}
          </div>
        )}

        {/* Action Button */}
        <button
          onClick={logout}
          className="px-6 py-3 bg-[#ec7026] text-white rounded-lg hover:bg-[#d85d1a] transition duration-200 font-medium font-['Semantic/Strong'] shadow-lg"
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
